interface AnalysisPreviewProps {
  grade: string;
}

function getGradeContext(grade: string): { headline: string; subhead: string } {
  switch (grade) {
    case 'A':
      return {
        headline: 'Great score. Planera helps you keep it that way.',
        subhead:
          'Top-performing schedules still drift over time. Planera monitors your schedule health continuously so you stay ahead of issues, not behind them.',
      };
    case 'B':
      return {
        headline: 'A solid foundation. Planera can take it further.',
        subhead:
          'Your schedule is in good shape, but there are areas that could expose you to risk. Planera pinpoints exactly where to tighten up before it costs you time and money.',
      };
    case 'C':
      return {
        headline: 'Your schedule has gaps. Planera closes them.',
        subhead:
          'A score like this often leads to missed deadlines and budget overruns. Planera identifies the specific issues dragging your score down and guides your team to fix them.',
      };
    default:
      return {
        headline: 'Your schedule needs attention. Planera can help.',
        subhead:
          'Schedules scoring below average are strongly correlated with cost overruns and delays. Planera helps teams rapidly improve schedule quality with actionable, criterion-level guidance.',
      };
  }
}

export function AnalysisPreview({ grade }: AnalysisPreviewProps) {
  const ctx = getGradeContext(grade);

  return (
    <div className="text-center space-y-3 animate-in fade-in slide-in-from-bottom-4 duration-500">
      <h3 className="text-xl font-bold text-foreground text-balance leading-tight sm:text-2xl">{ctx.headline}</h3>
      <p className="mx-auto max-w-md text-sm text-muted-foreground leading-relaxed text-pretty">{ctx.subhead}</p>
    </div>
  );
}
